/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'train',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M216,147.972H8c-4.418,0-8,3.582-8,8v128c0,4.418,3.582,8,8,8h208c4.418,0,8-3.582,8-8v-128
      C224,151.554,220.418,147.972,216,147.972z M208,275.972H16v-112h192V275.972z
      
      M224,339.972v-32c0-4.418-3.582-8-8-8H8c-4.418,0-8,3.582-8,8v32c0.002,3.179,1.886,6.056,4.8,7.328
			c-3.121,5.002-4.783,10.776-4.8,16.672c0,17.673,14.327,32,32,32s32-14.327,32-32c-0.033-5.634-1.569-11.157-4.448-16h104.896
			c-2.879,4.843-4.415,10.366-4.448,16c0,17.673,14.327,32,32,32s32-14.327,32-32c-0.017-5.896-1.679-11.67-4.8-16.672
			C222.114,346.029,223.998,343.152,224,339.972z M32,379.972c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16
			S40.837,379.972,32,379.972z M192,379.972c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S200.837,379.972,192,379.972z
       M208,331.972H16v-16h192V331.972z
       
      M480,339.972v-32c0-4.418-3.582-8-8-8H248c-4.418,0-8,3.582-8,8v32c0.002,3.179,1.886,6.056,4.8,7.328
			c-3.121,5.002-4.783,10.776-4.8,16.672c-0.078,17.598,14.125,31.927,31.722,32.005c9.321,0.041,18.192-4.001,24.278-11.061
			c11.444,13.345,31.54,14.887,44.885,3.442c11.731-10.059,14.542-27.091,6.667-40.386h72.896c-2.879,4.843-4.415,10.366-4.448,16
			c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32c-0.017-5.896-1.679-11.67-4.8-16.672
			C478.114,346.029,479.998,343.152,480,339.972z M272,379.972c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16
			S280.837,379.972,272,379.972z M320,379.972c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S328.837,379.972,320,379.972z
			 M448,379.972c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S456.837,379.972,448,379.972z M464,331.972H256v-16h208
      V331.972z
      
      M368,179.972c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8s8-3.582,8-8v-48C376,183.554,372.418,179.972,368,179.972z
      
      M336,179.972c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8s8-3.582,8-8v-48C344,183.554,340.418,179.972,336,179.972z

      M304,179.972c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8s8-3.582,8-8v-48C312,183.554,308.418,179.972,304,179.972z

      M479.76,282.028l-32-128c-0.892-3.559-4.091-6.056-7.76-6.056h-16v-40c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v40
			H248c-4.418,0-8,3.582-8,8v128c0,4.418,3.582,8,8,8h224c4.418,0,8-3.582,8-8C480,283.317,479.919,282.664,479.76,282.028z
			 M441.752,195.972l8,32H408v-32H441.752z M376,115.972h32v32h-32V115.972z M256,275.972v-112h177.752l4,16H400
      c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h53.752l8,32H256z
      
      ${utils.rect(32, 180, 16, 16)}
      
      ${utils.rect(32, 244, 16, 16)}
      
      ${utils.rect(80, 180, 16, 16)}
      
      ${utils.rect(80, 244, 16, 16)}
      
      ${utils.rect(128, 180, 16, 16)}
      ${utils.rect(128, 244, 16, 16)}
      ${utils.rect(176, 180, 16, 16)}
      ${utils.rect(176, 244, 16, 16)}
      
      ${utils.rect(312, 116, 32, 16)}
      ${utils.rect(264, 84, 80, 16)}

      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/train.js